module.exports = __webpack_public_path__ + "img/cleric.bbb851f1.png";